import { render, staticRenderFns } from "./PageMenusListe.vue?vue&type=template&id=9edd96ac&scoped=true&"
import script from "./PageMenusListe.vue?vue&type=script&lang=js&"
export * from "./PageMenusListe.vue?vue&type=script&lang=js&"
import style0 from "./PageMenusListe.vue?vue&type=style&index=0&id=9edd96ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edd96ac",
  null
  
)

export default component.exports